import { MediaType } from '../MediaType';
import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';

export const experimentalUpdateOpenInviteSettings: ExperimentalMutations['experimentalUpdateOpenInviteSettings'] =
	(_, { cloudId, settings }, { network: { cfetch } }) => {
		if (!cloudId) {
			throw new Error('cloudId is missing.');
		}
		if (!settings) {
			throw new Error('`settings` argument is missing');
		}

		const resource = `ari:cloud:confluence::site/${cloudId}`;

		return cfetch('/gateway/api/invitations/v1/settings/open-invite', {
			method: 'PUT',
			body: JSON.stringify({ resource, ...settings }),
			headers: {
				'Content-Type': MediaType.JSON,
			},
		}).then(() => ({
			// the endpoint returns 204 with empty response when succeeded
			success: true,
		}));
	};
